import {
  CLEAN_DIVISIONS,
  DELETE_DIVISION,
  ERROR,
  GET_DIVISION,
  LIST_DIVISIONS,
  SAVE_DIVISION,
  SET_RELOAD_DIVISIONS,
  START,
  SUCCESS
} from '../actions/types';
import { getError } from '../../utils/requestUtils';

const INITIAL_STATE = {
  divisions: [],
  division: null,
  pagination: null,
  reloadDivisions: false,

  listDivisions: {},
  getDivision: {},
  saveDivision: {},
  deleteDivision: {}
};

export default function reducer(state = INITIAL_STATE, action) {
  const data = action.payload?.data;
  const error = getError(action.payload);

  switch (action.type) {
    case LIST_DIVISIONS + START:
      return { ...state, listDivisions: { loading: true } };
    case LIST_DIVISIONS + SUCCESS:
      return {
        ...state,
        listDivisions: { loading: false },
        divisions: data.result.items,
        pagination: data.result.pagination
      };
    case LIST_DIVISIONS + ERROR:
      return { ...state, listDivisions: { loading: false, error } };

    case CLEAN_DIVISIONS + SUCCESS:
      return {
        ...state,
        listDivisions: { loading: false },
        divisions: [],
        pagination: null,
        ...action.payload
      };

    case GET_DIVISION + START:
      return { ...state, getDivision: { loading: true } };
    case GET_DIVISION + SUCCESS:
      return { ...state, getDivision: { loading: false }, division: data.item };
    case GET_DIVISION + ERROR:
      return { ...state, getDivision: { loading: false, error } };

    case SAVE_DIVISION + START:
      return { ...state, saveDivision: { loading: true } };
    case SAVE_DIVISION + SUCCESS:
      return { ...state, saveDivision: { loading: false }, division: data.item };
    case SAVE_DIVISION + ERROR:
      return { ...state, saveDivision: { loading: false, error } };

    case DELETE_DIVISION + START:
      return { ...state, deleteDivision: { loading: true } };
    case DELETE_DIVISION + SUCCESS:
      return {
        ...state,
        deleteDivision: { loading: false },
        divisions: state.divisions.filter((s) => s.id !== data.item.id)
      };
    case DELETE_DIVISION + ERROR:
      return { ...state, deleteDivision: { loading: false, error } };

    case SET_RELOAD_DIVISIONS:
      return { ...state, reloadDivisions: action.payload.reload };

    default:
      return { ...state };
  }
}
